import { captureException } from 'service-api/src/shared/monitoring'
import type { TGooseClaim, TGooseClaimLocation, TLocationUserProfile, TUser } from './types'

export const USER_STORE_KEY = 'BookingUserState'

export const isLocationValid = (claims: TGooseClaim[], location: string): boolean => {
  return claims?.findIndex((c) => c.locations?.findIndex((l) => l.name === location) >= 0) >= 0
}

export const getLocationData = (claims: TGooseClaim[], location: string): TGooseClaimLocation | undefined => {
  let rc: TGooseClaimLocation | undefined
  claims?.findIndex((c) => c.locations?.findIndex((l) => (l.name === location ? (rc = l) : false)) >= 0)
  return rc
}

export const resolveFromPathname = (claims: TGooseClaim[], pathName: string): TGooseClaimLocation | undefined => {
  const segments = pathName.split('/')
  if (segments.length < 2 || !segments[1]) {
    return
  }

  return getLocationData(claims, segments[1])
}

const userRegEx = RegExp(/^USR:([a-z0-9]*):SELF$/)
export const getCognitoUserId = (email: string, cognitoGroups?: string[]): string | undefined => {
  if (!cognitoGroups) {
    captureException(new ClientAuthError('Missing cognito:groups trying to get UserId'), { user: { id: '_', email } })
    return undefined
  }
  const userIdLabel = cognitoGroups.find((group: string) => userRegEx.test(group))

  if (!userIdLabel) {
    captureException(new ClientAuthError('Unable to decode userId'), { user: { id: '_', email } })
    return undefined
  }

  return userRegEx.exec(userIdLabel)![1]
}

const lupRegEx = RegExp(/^LUP:([A-Z\-a-z0-9]*):([a-z0-9]*)$/)
export const getCognitoLUPIds = (
  email: string,
  cognitoGroups?: string[],
  raiseError: boolean = true
): TLocationUserProfile[] | undefined => {
  if (!cognitoGroups) {
    if (raiseError) {
      captureException(new ClientAuthError('Missing cognito:groups trying to get LUPid'), { user: { id: '_', email } })
    }
    return undefined
  }
  const lupIdLabels = cognitoGroups.filter((group: string) => lupRegEx.test(group))

  if (lupIdLabels.length === 0) {
    if (raiseError) {
      captureException(new ClientAuthError('Unable to decode LUP'), { user: { id: '_', email } })
    }
    return undefined
  }

  return lupIdLabels.map((label: string) => ({
    locationName: lupRegEx.exec(label)![1],
    lupId: lupRegEx.exec(label)![2],
  }))
}

export const isUserLoggedIn = (user?: TUser): boolean => !!user?.token

export const getLocationFromUrl = (url?: string): string => {
  if (!url) {
    return ''
  }
  const segments = url.split('/')
  return segments[1]
}

export class ClientAuthError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ClientAuthError'
  }
}
